import { Headline, Body } from '@shipt/design-system-typography'
import styled from 'styled-components'
import { useCurrentUniversalCategory } from '@/features/shop/services/UniversalCategories/hooks'
import {
  getUniversalCategories,
  findCategoryById,
  urlBuilder,
} from '@/features/shop/services/UniversalCategories/utils'
import { CategoryBreadcrumb } from '@/features/shop/components/UngatedProductDetail/CategoryBreadcrumb'
import { Box, Column, Row } from '@shipt/design-system-layouts'
import { NextLink } from '@/features/shared/elements/Link'
import { ArrowLeftIcon } from '@shipt/design-system-icons'
import { useSearchQueryParams } from '@/features/shared/hooks/search'
import { screenSizes } from '@shipt/design-system-themes'

export const ProductGridHeading = ({ className }: { className: string }) => {
  const currentCategory = useCurrentUniversalCategory()
  const pageCategoryName = currentCategory?.name ?? ''
  const categoryTitle = `${pageCategoryName} Delivery`
  const searchParams = useSearchQueryParams()
  const zipParam = String(searchParams.zip ?? '')
  const universalCategories = getUniversalCategories()

  const hierarchy = (
    currentCategory?.ancestors?.map((id) => findCategoryById(universalCategories, id)) ?? []
  ).filter((cat) => !!cat)

  return (
    <div className={className}>
      {!!currentCategory && (
        <>
          <Box display={{ base: 'none', md: 'block' }}>
            <CategoryBreadcrumb
              categories={[...hierarchy, currentCategory]}
              includeCategoriesLink
            />
          </Box>
          {hierarchy.length > 0 && (
            <NextLink
              href={urlBuilder({
                universalCategories,
                category: hierarchy.at(-1),
                zip: zipParam,
              })}
            >
              <Row
                display={{ base: 'flex', md: 'none' }}
                align="center"
                spacing="sm"
                marginBottom="lg"
              >
                <ArrowLeftIcon size="md" />
                <Body variant="primary">{hierarchy.at(-1)?.name}</Body>
              </Row>
            </NextLink>
          )}
        </>
      )}
      <Column spacing="md">
        <Headline size="xl" as="h1">
          {categoryTitle}
        </Headline>
        <Body variant="secondary">Delivered to your door in as soon as an hour.</Body>
        <Divider />
      </Column>
    </div>
  )
}

const Divider = styled.hr`
  border: 0.5px solid ${({ theme }) => theme.color.border.base.neutral.soft};
  width: 100%;

  @media ${screenSizes.lgDesktop} {
    width: 102%;
  }
`
